import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';
import { PaginationType } from 'services/api/type/booking.type';
import get from 'lodash/get';
import { TravelAgencyResponse } from '@/services/api/type/travel-agency.type';
import { ONE_DAY_IN_MS, ONE_HOUR_IN_MS } from 'constants/time';

export const useGetTravelAgency = (id?: number, enable: boolean = true) => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.GET_TRAVEL_AGENCIES, id],
    queryFn: () => API.ta.getTravelAgency(Number(id)),
    enabled: !!id && enable
  });

  return {
    data: data,
    isLoading
  };
};

export const useGetTravelAgencies = (values?: any, limit?: number, page?: number) => {
  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.GET_TRAVEL_AGENCIES, values, page],
    queryFn: () => API.ta.getTravelAgencies(values, limit, page),
    enabled: !!values,
    staleTime: ONE_HOUR_IN_MS, // 1 hour fresh
    gcTime: ONE_DAY_IN_MS
  });

  return {
    data: get(data, 'data', []) as TravelAgencyResponse[],
    pagination: get(data, 'pagination', {}) as PaginationType,
    isLoading
  };
};
